'use client'

import { cva } from 'class-variance-authority'
import type { VariantProps } from 'class-variance-authority'
import { cn } from '@/utils'

export interface DividerProps extends VariantProps<typeof dividerVariants> {
  /** Width of the divider */
  width?: string | number
  /** Additional CSS classes */
  className?: string
}

const dividerVariants = cva('h-px flex-shrink-0', {
  variants: {
    pattern: {
      light: 'bg-gray-300 border-gray-300',
      dark: 'bg-gray-500 border-gray-500',
    },
    state: {
      solid: 'h-px',
      dashed: 'border border-dashed bg-white',
      dotted: 'border border-dotted bg-white',
    },
  },
  defaultVariants: {
    pattern: 'light',
    state: 'solid',
  },
})

export const Divider: React.FC<DividerProps> = ({
  pattern,
  state,
  width = '100%',
  className,
  ...props
}) => {
  return (
    <div
      className={cn(dividerVariants({ pattern, state }), className)}
      style={{ width: typeof width === 'number' ? `${width}px` : width }}
      data-testid="divider"
      {...props}
    />
  )
}
